import { Box } from '@chakra-ui/react'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

const CurrentHoveringAreaTooltip = () => {
  // Store
  const inspectionAreas = useSelector((state: RootState) => state.page.inspectionAreas)
  const currentHoveringAreaId = useSelector((state: RootState) => state.pcdAlignment.currentHoveringArea)
  const currentHoveringArea = inspectionAreas.find((area) => area.inspection_area_id === currentHoveringAreaId)

  if (!currentHoveringArea) return null

  return (
    <Box
      position="absolute"
      bottom="10px"
      left="50%"
      transform="translateX(-50%)"
      background="gray2.900"
      color="whiteAlpha.600"
      px={2}
      borderRadius={4}
      zIndex={90}
    >
      {currentHoveringArea.inspection_area_name}
    </Box>
  )
}

export default CurrentHoveringAreaTooltip
